import {EntityArray} from '../../core/entityArray';
import {Helper} from '../../helpers/helper';
import {LookinChatSDK} from '../../lib/lookinChatSDK';
import {Request} from '../request';

import {MessageContent} from './messageContent';
import {MessageState, MessageStateType} from './messageState';

/**
 * @ignore
 * @internal
 * */
export class MessageRequest extends Request {
  type: MessageStateType[] = ['create']
  messageId: string = null;
  groupId: string;
  clientId: string;
  data: MessageRequestData = null;

  constructor(type: MessageStateType[] = ['create'], groupId: string, state: MessageState = null, content: MessageContent = null, messageId: string = null) {
    super();

    this.type = type;
    this.groupId = groupId;
    this.messageId = messageId;
    this.clientId = '';

    this.data = new MessageRequestData(state, content)
    this.clientId = Helper.getRandomClientId(this.groupId + LookinChatSDK.user.id);
  }

  isType(type: MessageStateType) {
    return this.type.includes(type);
  }
}

class MessageRequestData {
  state: EntityArray<MessageState> = new EntityArray<MessageState>();
  content: MessageContent;

  constructor(state: MessageState = null, content: MessageContent = null) {
    if (state) {
      this.state.push(state);
    }

    this.content = content;
  }
}
